import React, { Component } from "react";
import Select from "react-select";
import AppContext from "../../../contexts/AppContext";

class CreateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                category_id : '',
                article_id: '',
            },
            selectedcat: 'Select Category',
            selectedarticle: 'Select Article',
            errors: {}
        };
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        
        if(!fields.category_id){
            formIsValid = false;
            errors.category_id = "Please select category";
        }  
        
        if(!fields.article_id){
            formIsValid = false;
            errors.article_id = "Please select article";
        }   

        this.setState({errors: errors});
        return formIsValid;
    }

    create = e => {
        e.preventDefault();
        if(this.handleValidation()){
            this.props
            .create(this.state.item)
            .then(response => {
                this.props.hideCreate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });
        }        
    };

    handlecatSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.category_id = selectedOption.value;        
        let error = this.state.errors;
        error.category_id = null;                  
        this.setState({ item: temp, errors: error, selectedcat:selectedOption.name });   
    };

    handlearticleSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.article_id = selectedOption.value;        
        let error = this.state.errors;
        error.article_id = null;                
        this.setState({ item: temp, errors: error, selectedarticle:selectedOption.name });        
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Create record</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="name">Category</label>
                                <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="category_id"
                                                id="category_id" 
                                                value={this.state.item.category_id}   
                                                placeholder = {this.state.selectedcat}                                           
                                                onChange={
                                                    this
                                                        .handlecatSelectChange
                                                }                                              
                                                options={
                                                    this.props.cats
                                                }
                                            ></Select>
                                {this.state.errors.category_id ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.category_id}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="name">Articles</label>
                                <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="article_id"
                                                id="article_id" 
                                                value={this.state.item.article_id}   
                                                placeholder = {this.state.selectedarticle}                                              
                                                onChange={
                                                    this
                                                        .handlearticleSelectChange
                                                }                                              
                                                options={
                                                    this.props.posts
                                                }
                                            ></Select>
                                {this.state.errors.article_id ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.article_id}
                                    </div>
                                ) : null}
                            </div>
                            <button
                                type="button"
                                onClick={this.create}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreateModel.contextType = AppContext;
export default CreateModel;



// WEBPACK FOOTER //
// ./src/components/admin/posts/CreateModel.js